import { Route } from "react-router-dom";

import {
  CoaPrintPreview,
  LoiPrintPreview,
  DlnPrintPreview,
  QuoPrintPreview,
  SptPrintPreview,
  EstPrintPreview,
  PspPrintPreview,
  JoPrintPreview,
  JoInvoicePrintPreview,
  PlPGPrintPreview,
  DelPrintPreview,
  PackingListPrintPreview,
  InvoicePrintPreview,
  ProformaPrintPreview,
  MpPrintPreview,
  PoPrintPreview,
  GrQcPrintPreview,
  GrQcDailyPrintPreview,
  GrTagsPrintPreview,
  JoLabelPrintPreview,
  PdRequisitionPrintPreview,
  PdWorkOrderPreview,
  PdTrimRoomPrintPreview,
  PdCuringRoomPrintPreview,
} from "../components/print";

export const PrintRouter = (
  <>
    <Route path="/coa-print/:code/:print?" element={<CoaPrintPreview />} />
    <Route path="/loi-print/:code/:print?" element={<LoiPrintPreview />} />
    <Route path="/dln-print/:code/:print?" element={<DlnPrintPreview />} />
    <Route path="/quo-print/:code/:print?" element={<QuoPrintPreview />} />
    <Route path="/spt-print/:code/:print?" element={<SptPrintPreview />} />
    <Route path="/est-print/:code/:print?" element={<EstPrintPreview />} />
    <Route path="/psp-print/:code/:version?" element={<PspPrintPreview />} />
    <Route path="/jo-print/:code/:version?" element={<JoPrintPreview />} />
    <Route path="/jo-invoice-print/:code/:version?" element={<JoInvoicePrintPreview />} />
    <Route path="/pl-pg-print/:code/:version?" element={<PlPGPrintPreview />} />
    <Route path="/del-print/:code/:print?" element={<DelPrintPreview />} />
    <Route path="/packing-list-print/:code/:print?" element={<PackingListPrintPreview />} />
    <Route path="/inv-print/:code/:print?" element={<InvoicePrintPreview />} />
    <Route path="/pi-print/:code/:print?" element={<ProformaPrintPreview />} />
    <Route path="/mp-print/:code/:mpid?" element={<MpPrintPreview />} />
    <Route path="/po-print/:code/:print?" element={<PoPrintPreview />} />
    <Route path="/gr-qc-print/:code/:print?" element={<GrQcPrintPreview />} />
    {/* พิมพ์บันทึกตรวจรับวัตถุดิบ (QC) รายวัน — date รูปแบบ YYYY-MM-DD */}
    <Route path="/gr-qc-print-daily/:date" element={<GrQcDailyPrintPreview />} />
    <Route path="/gr-tags-print/:code/:print?" element={<GrTagsPrintPreview />} />
    {/* Tags ของ JU ใช้ฟอร์มเดียวกับ GR */}
    <Route path="/ju-tags-print/:code" element={<GrTagsPrintPreview source="ju" />} />
    {/* ใบสั่งงานปิดฉลาก — code คือ er_jo_ver_detail.code ตัวเดียวกับ Packing Information */}
    <Route path="/jo-label-print/:code/:print?" element={<JoLabelPrintPreview />} />
    {/* ใบขอเบิกเพื่อเตรียมการผลิตประจำวัน — code คือ pdcode */}
    <Route path="/pd-requisition-print/:code/:print?" element={<PdRequisitionPrintPreview />} />
    <Route path="/pd-work-order/:code" element={<PdWorkOrderPreview />} />
    <Route path="/pd-trim-room/:code" element={<PdTrimRoomPrintPreview />} />
    <Route path="/pd-curing-room/:code" element={<PdCuringRoomPrintPreview />} />
  </>
);

